import { type FC } from "react";
import { Button } from "@capacit-com/lara-law-shared-ui";
import { Mail, UsersRound } from "lucide-react";
import { PermissionGate } from "@/lib/permissions/PermissionGate";
import { Permission } from "@/lib/permissions/Permission.enum";
import { useUserManagementContext } from "@/providers/user-management/UserManagementContext";
import { UserManagementTabs } from "../utils/userManagementTabs";

interface UserManagementPrimaryActionProps {
  tab: UserManagementTabs;
}

/**
 * The sub-tab's organisation-level create action, alone at the right end of the page header.
 * "Inviter bruger" and "Opret gruppe" therefore land in the same place as each other, away from
 * the table-scoped actions on the search row below.
 */
const UserManagementPrimaryAction: FC<UserManagementPrimaryActionProps> = ({
  tab,
}) => {
  const { setOpenInviteUserDialog, setOpenCreateGroupDialog } =
    useUserManagementContext();

  if (tab === UserManagementTabs.INVITED_USERS) {
    return (
      <PermissionGate allOf={[Permission.CreateOrganizationInvitation]}>
        <Button
          variant="default"
          size="sm"
          className="shrink-0"
          onClick={() => setOpenInviteUserDialog(true)}
        >
          <Mail className="w-4 h-4 mr-2" />
          Inviter bruger
        </Button>
      </PermissionGate>
    );
  }

  if (tab === UserManagementTabs.GROUPS) {
    return (
      <PermissionGate allOf={[Permission.CreateFeatureGroups]}>
        <Button
          variant="default"
          size="sm"
          className="shrink-0"
          onClick={() => setOpenCreateGroupDialog(true)}
        >
          <UsersRound className="w-4 h-4 mr-2" />
          Opret gruppe
        </Button>
      </PermissionGate>
    );
  }

  return null;
};

export default UserManagementPrimaryAction;
